import React from "react";
import { Form, ModalBuilder, notifySuccess } from "@redriver/cinnamon";
import { useTranslation } from "react-i18next";
import { TranslatedModal } from "../../../../../../../shared/components/modals";
import { setPhysicalDocumentSheetState } from "./actions";
import {
  LookupNames as SheetLookupNames,
  ActionTypes as SheetActionTypes,
} from "../../../../Sheets/lookups";
import { useDispatch } from "react-redux";
import { DropdownItem } from "semantic-ui-react";
import { NonPropagatingDropdown } from "features/../../../shared/components/forms/NonPropagatingField";

const SetPhysicalDocumentSheetState = ({ sheet, onSubmitted }) => {
  const { t } = useTranslation("agreements");
  const dispatch = useDispatch();
  const { sheetId } = sheet;
  const tradeAsIps = process.env.TRADE_AS_IPS;

  return (
    <ModalBuilder
      withForm
      submitParams={{ sheetId }}
      submitAction={setPhysicalDocumentSheetState}
      onSubmitted={() => {
        dispatch(notifySuccess("Sheet status changed successfully"));
        onSubmitted();
      }}
      renderTrigger={(onTrigger) => (
        <DropdownItem onClick={onTrigger}>
          {t("SheetActions.SetStatus.TriggerText")}
        </DropdownItem>
      )}
      renderModal={(modalProps, formProps) => (
        <TranslatedModal.Edit
          {...modalProps}
          header={t("SheetActions.SetStatus.ModalHeader")}
          submitText={t("SheetActions.SetStatus.ModalSubmit")}
        >
          <Form {...formProps}>
            <NonPropagatingDropdown
              field={tradeAsIps ? "stateIps" : "statePrincipal"}
              placeholder={t("SheetActions.SetStatus.Placeholder")}
              lookup={
                tradeAsIps
                  ? SheetLookupNames[SheetActionTypes.PhysicalSheetStateIps]
                  : SheetLookupNames[
                      SheetActionTypes.PhysicalSheetStatePrincipal
                    ]
              }
              lookupParams={{
                excludeNotSettable: true,
              }}
            />
          </Form>
        </TranslatedModal.Edit>
      )}
    />
  );
};

export default SetPhysicalDocumentSheetState;
